import React from "react";
import { Mic, MicOff } from "lucide-react";

export default function PTTButton({ transmitting, onStart, onStop, disabled }) {
  return (
    <div className="flex flex-col items-center gap-2 select-none">
      <button
        disabled={disabled}
        onMouseDown={onStart}
        onMouseUp={onStop}
        onTouchStart={(e) => { e.preventDefault(); onStart(); }}
        onTouchEnd={(e)   => { e.preventDefault(); onStop();  }}
        className={`w-24 h-24 rounded-full flex items-center justify-center text-white text-3xl
          transition-all duration-150 active:scale-95
          ${disabled ? "bg-gray-700 cursor-not-allowed" :
            transmitting
              ? "bg-green-500 ptt-active shadow-lg shadow-green-500/40"
              : "bg-brand hover:bg-brand-dark shadow-md"
          }`}
      >
        {transmitting ? <Mic className="w-10 h-10" /> : <MicOff className="w-10 h-10" />}
      </button>
      <p className="text-xs text-gray-400 font-medium">
        {disabled ? "Join a channel" : transmitting ? "Transmitting…" : "Hold to Talk"}
      </p>
    </div>
  );
}
